/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ShopQueryResultItem model module.
 * @module model/ShopQueryResultItem
 * @version 1.0
 */
class ShopQueryResultItem {
    /**
     * Constructs a new <code>ShopQueryResultItem</code>.
     * @alias module:model/ShopQueryResultItem
     */
    constructor() { 
        
        ShopQueryResultItem.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ShopQueryResultItem</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ShopQueryResultItem} obj Optional instance to populate.
     * @return {module:model/ShopQueryResultItem} The populated <code>ShopQueryResultItem</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ShopQueryResultItem();

            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'String');
            }
            if (data.hasOwnProperty('deletedAt')) {
                obj['deletedAt'] = ApiClient.convertToType(data['deletedAt'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('price')) {
                obj['price'] = ApiClient.convertToType(data['price'], 'Number');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} createdAt
 */
ShopQueryResultItem.prototype['createdAt'] = undefined;

/**
 * @member {String} deletedAt
 */
ShopQueryResultItem.prototype['deletedAt'] = undefined;

/**
 * @member {Number} id
 */
ShopQueryResultItem.prototype['id'] = undefined;

/**
 * @member {String} name
 */
ShopQueryResultItem.prototype['name'] = undefined;

/**
 * @member {Number} price
 */
ShopQueryResultItem.prototype['price'] = undefined;

/**
 * @member {String} updatedAt
 */
ShopQueryResultItem.prototype['updatedAt'] = undefined;






export default ShopQueryResultItem;

